const brands = {
  featuredBrands: "Featured brands",
  allBrands: "All brands",
  backToTop: "Back to top",
} as const;

export { brands };
